import { render, staticRenderFns } from "./RecipientEmailDisplay.vue?vue&type=template&id=7a261514&scoped=true&"
import script from "./RecipientEmailDisplay.vue?vue&type=script&lang=js&"
export * from "./RecipientEmailDisplay.vue?vue&type=script&lang=js&"
import style0 from "./RecipientEmailDisplay.vue?vue&type=style&index=0&id=7a261514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a261514",
  null
  
)

export default component.exports